import React from 'react'
import { TabButtonGroup } from 'src/Components/TabButton'

export interface ButtonAction {
  label?: string
  id: string
  icon?: React.ReactNode
  disabled?: boolean
}

export interface ButtonGroupProps {
  actions: ButtonAction[]
  onChange: (index: number) => void
  active?: number
  disabled?: boolean
  fullWidth?: boolean
}

const FormikTabButtonGroup: React.FC<ButtonGroupProps> = ({ actions, onChange, active, disabled, fullWidth }) => {
  const wrappedOptions = actions.map((action, index) => ({
    ...action,
    onChange: () => onChange(index),
  }))

  return <TabButtonGroup options={wrappedOptions} active={active} disabled={disabled} fullWidth={fullWidth} />
}

export default FormikTabButtonGroup
